<template>
  <myFormVue addTitle="Add New Podcast" updateTitle="Update Podcast" :submitLoading="submitLoading"
    :isUpdating="dataObj == null" :step="step_no" :step_count="1" @stepForward="stepForward"
    @stepBackward="stepBackward" @submit="submit" @onFileInit="initFile" @closeModal="$emit('closeModal')">
    <div class="modal_body_part split_step">
      <div class="split_part_data">
        <h1 class="title">Details</h1>
        <div class="data-form">
          <b-field label="Name (Required)">
            <b-input v-model="form.name" type="text" placeholder="Enter Name"></b-input>
          </b-field>
          <b-field label="Description">
            <b-input type="textarea" v-model="form.description" placeholder="Enter Description"></b-input>
          </b-field>
          <b-field label="Thumbnail Image">
            <p class="b-field-txt">Select or upload cover image that stands as cover image for the serie. A good cover
              image stands out and draws viewers’ attention.</p>
          </b-field>
          <upload-trigger :open="false" :enableinput="false" :required="false" :multiple="false"
            location="assets/uploaded/" :url="$store.state.ASSETS_BASE_URL"
            :uploadurl="$store.state.BASE_URL + 'upload'" name="main-image" :value="form.cover" @onFileSelected="(file) => {
              form.cover = file;
            }
              ">
            <div class="image-upload-widget">Choose Image</div>
          </upload-trigger><br>
          <b-field label="Released Year (Required)">
            <b-input v-model="form.year" type="input" placeholder="Enter Release Year"></b-input>
          </b-field>
          <h1 class="title">Visibility (Required)</h1>
          <div class="data-form">
            <div class="visibility-grp">
              <h1 class="visibility-grp-title">Save or Publish</h1>
              <p class="visibility-grp-sub">Make your music public, unlisted, or private</p>
              <div class="visibility-togglers">
                <div class="visibility-togglers-each">
                  <h1>
                    <b-radio v-model="form.visibility" native-value="private" type="is-success" size="is-small">
                    </b-radio>
                    Private
                  </h1>
                  <p>Only you and people you choose can watch your video</p>
                </div>
                <div class="visibility-togglers-each">
                  <h1>
                    <b-radio v-model="form.visibility" native-value="unlisted" type="is-success" size="is-small">
                    </b-radio>
                    Unlisted
                  </h1>
                  <p>Anyone with the music link can watch your music</p>
                </div>
                <div class="visibility-togglers-each">
                  <h1>
                    <b-radio v-model="form.visibility" native-value="public" type="is-success" size="is-small">
                    </b-radio>
                    Public
                  </h1>
                  <p>Everyone can watch your video</p>
                </div>
              </div>
            </div>
          </div>
          <br>
          <b-field label="Director/s">
            <b-taginput v-model="form.directors" :data="allDirectors" :before-adding="beforeAddingDirectors"
              autocomplete ref="directorTagInput" icon="label" placeholder="Enter Director(s)" @typing="searchDirector">
              <template slot-scope="props">
                <strong>{{ props.option.index }}</strong>: {{ props.option.name }}
              </template>
              <template #empty>
                There are no items
              </template>
              <template #selected="props">
                <b-tag v-for="(tag, index) in props.tags" :key="index" rounded :tabstop="false" ellipsis closable
                  @close="$refs.directorTagInput.removeTag(index, $event)">
                  {{ tag.name ? tag.name : tag }}
                </b-tag>
              </template>
            </b-taginput>
          </b-field>
          <b-field label="Topic/s">
            <b-taginput v-model="form.topics" :data="allTopics" :before-adding="beforeAddingTopics" autocomplete
              ref="topicTagInput" icon="label" placeholder="Enter Topic(s)" @typing="searchTopics">
              <template slot-scope="props">
                <strong>{{ props.option.index }}</strong>: {{ props.option.name }}
              </template>
              <template #empty>
                There are no items
              </template>
              <template #selected="props">
                <b-tag v-for="(tag, index) in props.tags" :key="index" rounded :tabstop="false" ellipsis closable
                  @close="$refs.topicTagInput.removeTag(index, $event)">
                  {{ tag.name ? tag.name : tag }}
                </b-tag>
              </template>
            </b-taginput>
          </b-field>
          <b-field label="Playlist/s">
            <b-taginput v-model="form.playlist" :data="allPlaylists" :before-adding="beforeAddingPlaylists" autocomplete
              ref="playlistTagInput" icon="label" placeholder="Enter Playlist(s)" @typing="searchPlaylist">
              <template slot-scope="props">
                <strong>{{ props.option.index }}</strong>: {{ props.option.name }}
              </template>
              <template #empty>
                There are no items
              </template>
              <template #selected="props">
                <b-tag v-for="(tag, index) in props.tags" :key="index" rounded :tabstop="false" ellipsis closable
                  @close="$refs.playlistTagInput.removeTag(index, $event)">
                  {{ tag.name ? tag.name : tag }}
                </b-tag>
              </template>
            </b-taginput>
          </b-field>
        </div>
      </div>
      <div class="split_part_view">
        <div class="data_cover">
          <img v-if="form.cover" :src="$store.state.ASSETS_BASE_URL + 'assets/uploaded/' + form.cover"
            alt="Cover Image">
          <b-skeleton v-else id="img-skeleton"></b-skeleton>
          <span class="indicator">Published</span>
        </div>
        <h1 class="name" v-if="form.name">{{ form.name }}</h1>
        <h1 class="name" v-else>
          <b-skeleton width="80%"></b-skeleton>
        </h1>
        <p class="descr" v-if="form.description">{{ form.description }}</p>
        <div class="spaced-skeleton" v-else>
          <b-skeleton></b-skeleton>
          <b-skeleton width="85%"></b-skeleton>
          <b-skeleton width="75%"></b-skeleton>
        </div>
      </div>
    </div>
  </myFormVue>
</template>

<script>
import myFormVue from '../components/myForm.vue';
export default {
  props: {
    dataObj: {
      type: Object,
      default: null
    }
  },
  components: { myFormVue },
  data() {
    return {
      isPlaying: false,
      filteredTags: null,
      step_no: 1,
      allDirectors: null,
      allTopics: null,
      allPlaylists: null,
      submitLoading: false,
      form: {
        cover: null,
        name: '',
        description: '',
        visibility: '',
        directors: [],
        year: '',
        playlist: [],
        topics: [],
        mediaId: null
      }
    }
  },
  mounted() {
    let vm = this;
    if (vm.dataObj) {
      vm.step_no = 1
      vm.form = {
        cover: vm.dataObj.cover,
        name: vm.dataObj.title,
        description: vm.dataObj.description,
        visibility: vm.dataObj.visibility,
        directors: vm.dataObj.directors,
        year: vm.dataObj.release_year,
        playlist: vm.dataObj.playlists,
        topics: vm.dataObj.topic,
        mediaId: vm.dataObj.videoId
      }
    } else {
      vm.form = {
        cover: null,
        name: '',
        description: '',
        visibility: '',
        directors: [],
        year: '',
        playlist: [],
        topics: [],
        mediaId: null
      }
    }
  },
  methods: {
    stepForward() {
      let vm = this;
      if (vm.step_no < 3) {
        vm.step_no++;
      }
    },
    stepBackward() {
      let vm = this;
      if (vm.step_no != 1) {
        vm.step_no--;
      }
    },
    initFile(mediaId) {
      let vm = this;
      vm.form.mediaId = mediaId;
    },
    searchTopics(param) {
      let vm = this;
      vm.$store.dispatch('GET_PODCASTS_TOPICS', { name: param })
        .then((res) => {
          vm.allTopics = res.data.return.map((each, index) => {
            return {
              id: each.id,
              index: index + 1,
              name: each.name,
              from_db: true
            }
          });
          // Filter out the artists that are not already selected
          vm.allTopics = vm.allTopics.filter((each) => {
            return vm.form.topics.find((item) => {
              return item.id == each.id
            }) == null
          });
          if (vm.allTopics.length == 0) {
            vm.allTopics = [{
              id: 0,
              index: 1,
              name: param,
              from_db: false
            }]
            // Filter out the artists that are not already selected
            vm.allTopics = vm.allTopics.filter((each) => {
              return vm.form.topics.find((item) => {
                return item.name.toLowerCase() == each.name.toLowerCase();
              }) == null
            });
          }
        })
    },
    beforeAddingTopics(tag) {
      if (tag.from_db) {
        return this.form.topics.find(item => item.id === tag.id) == null;
      } else {
        return this.form.topics.find(item => item.name === tag.name) == null;
      }
    },
    searchPlaylist(param) {
      let vm = this;
      vm.$store.dispatch('GET_PODCASTS_PLAYLISTS', { name: param })
        .then((res) => {
          vm.allPlaylists = res.data.return.map((each, index) => {
            return {
              id: each.id,
              index: index + 1,
              name: each.name,
              from_db: true
            }
          });
          // Filter out the artists that are not already selected
          vm.allPlaylists = vm.allPlaylists.filter((each) => {
            return vm.form.playlist.find((item) => {
              return item.id == each.id
            }) == null
          });
          if (vm.allPlaylists.length == 0) {
            vm.allPlaylists = [{
              id: 0,
              index: 1,
              name: param,
              from_db: false
            }]
            // Filter out the artists that are not already selected
            vm.allPlaylists = vm.allPlaylists.filter((each) => {
              return vm.form.playlist.find((item) => {
                return item.name.toLowerCase() == each.name.toLowerCase();
              }) == null
            });
          }
        })
    },
    beforeAddingPlaylists(tag) {
      if (tag.from_db) {
        return this.form.playlist.find(item => item.id === tag.id) == null;
      } else {
        return this.form.playlist.find(item => item.name === tag.name) == null;
      }
    },
    searchDirector(param) {
      let vm = this;
      vm.$store.dispatch('GET_PODCASTS_DIRECTORS', { name: param })
        .then((res) => {
          vm.allDirectors = res.data.return.map((each, index) => {
            return {
              id: each.id,
              index: index + 1,
              name: each.name,
              from_db: true
            }
          });
          // Filter out the artists that are not already selected
          vm.allDirectors = vm.allDirectors.filter((each) => {
            return vm.form.directors.find((item) => {
              return item.id == each.id
            }) == null
          });
          if (vm.allDirectors.length == 0) {
            vm.allDirectors = [{
              id: 0,
              index: 1,
              name: param,
              from_db: false
            }]
            // Filter out the artists that are not already selected
            vm.allDirectors = vm.allDirectors.filter((each) => {
              return vm.form.directors.find((item) => {
                return item.name.toLowerCase() == each.name.toLowerCase();
              }) == null
            });
          }
        })
    },
    beforeAddingDirectors(tag) {
      if (tag.from_db) {
        return this.form.directors.find(item => item.id === tag.id) == null;
      } else {
        return this.form.directors.find(item => item.name === tag.name) == null;
      }
    },
    submit() {
      let vm = this;
      if (vm.form.visibility && vm.form.name && vm.form.year) {
        vm.submitLoading = true;
        if (vm.dataObj) {
          vm.form.id = vm.dataObj.id;
          vm.$store.dispatch('UPDATE_PODCASTS', vm.form)
            .then((res) => {
              vm.$notify({
                group: "status",
                type: "success",
                title: "SUCCESS!!!",
                text: 'Podcast Updated Successfully',
              });
              vm.submitLoading = false;
              vm.$emit('closeModal');
              vm.$emit('refresh');
            })
            .catch((err) => {
              vm.$notify({
                group: "status",
                type: "error",
                title: "OOPS!!!",
                text: 'Something went wrong',
              });
              vm.submitLoading = false;
            })
        } else {
          vm.$store.dispatch('ADD_PODCASTS', vm.form)
            .then((res) => {
              vm.submitLoading = false;
              vm.$emit('closeModal');
              vm.$emit('refresh');
              vm.$notify({
                group: "status",
                type: "success",
                title: "SUCCESS!!!",
                text: 'Podcast Added Successfully',
              });
            })
            .catch((err) => {
              vm.submitLoading = false;
              console.log(err)
              vm.$notify({
                group: "status",
                type: "error",
                title: "OOPS!!!",
                text: 'Something went wrong',
              });
            })
        }
      } else {
        vm.$notify({
          group: "status",
          type: "error",
          title: "OOPS!!!",
          text: 'Please fill all required fields',
        });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.main_modal {
  position: fixed;
  width: 100%;
  height: calc(100% - 60px);
  background: rgba(0, 0, 0, 0.268);
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  padding: 20px 0;
  align-items: center;
  overflow-y: scroll;
  transition: .8s;
  z-index: 20;

  @media (max-height: 859px) {
    align-items: flex-start;
  }

  @media (max-width: 450px) {
    padding: 0;
  }

  &.activeSide {
    width: calc(100% - 230px);

    @media (max-width: 966px) {
      width: 100%;
    }

    .main_modal_crd {
      .modal_body {
        .modal_body_part {
          &.split_step {
            @media (max-width: 1162px) {
              grid-template-columns: 58% 40%;
            }

            @media (max-width: 768px) {
              grid-template-columns: 100%;
              row-gap: 20px;
            }
          }
        }
      }
    }
  }

  .main_modal_crd {
    width: 90%;
    background: white;
    min-height: 300px;
    height: fit-content;
    border-radius: 10px;
    position: relative;
    overflow: hidden;

    @media (max-width: 580px) {
      width: 95%;
    }

    @media (max-width: 450px) {
      width: 100%;
      border-radius: 0;
      height: calc(100vh - 60px);
    }

    .modal_top {
      display: flex;
      padding: 16px 23px;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #dfdfdf;
      position: sticky;
      top: 0;

      h1 {
        font-size: 17px;
        font-weight: 600;
      }

      span {
        cursor: pointer;
      }
    }

    .modal_body {
      height: 550px;
      overflow-y: auto;
      padding: 10px 23px 75px;

      @media (max-width: 580px) {
        padding-bottom: 100px;
      }

      @media (max-width: 450px) {
        padding-bottom: 75px;
        height: 88%;
      }

      .modal_body_part {
        &.upload_step {
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;

          .upload_cover {
            display: flex;
            width: 90px;
            height: 90px;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
            background: #D9D9D9;
            margin-bottom: 20px;
          }

          h1 {
            font-weight: 600;
            margin-bottom: 5px;
          }

          p {
            opacity: .7;
            text-align: center;
            // margin-bottom: 20px;
          }

          .upload-trigger {
            width: 40%;
            margin-top: 20px;
          }
        }

        &.split_step {
          display: grid;
          grid-template-columns: 68% 30%;
          justify-content: space-between;

          @media (max-width: 1000px) {
            grid-template-columns: 58% 40%;
          }

          @media (max-width: 768px) {
            grid-template-columns: 100%;
            row-gap: 20px;
          }

          .split_part_data {
            h1.title {
              margin-bottom: 15px;
              font-size: 23px;
            }

            .b-field-txt {
              opacity: .6;
              display: flex;

              &.mbottom {
                margin-bottom: 10px;
              }
            }

            .taginput.control {
              display: flex;
            }

            .upload-trigger {
              width: 200px;
            }

            .visibility-grp {
              .visibility-grp-title {
                font-weight: 700;
              }

              .field.has-numberinput {
                width: 200px;
              }

              .field {
                .field-body {
                  .field.has-addons {
                    border: 1px solid red;
                  }
                }
              }

              .visibility-grp-sub {
                opacity: .7;
              }

              .visibility-togglers {
                margin-top: 10px;
                display: flex;
                flex-direction: column;
                row-gap: 10px;
                padding-left: 40px;

                .visibility-togglers-each {
                  h1 {
                    display: flex;
                  }
                }
              }
            }
          }

          .split_part_view {
            .data_cover {
              height: 300px;
              border-radius: 10px;
              overflow: hidden;
              position: relative;
              margin-bottom: 13px;

              .b-skeleton {
                height: 100%;

                .b-skeleton-item {
                  height: 100%;
                }
              }

              img {
                height: 100%;
                width: 100%;
                object-fit: cover;
              }

              .media {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 50px;
                height: 50px;
                display: flex;
                justify-content: center;
                align-items: center;
                background: white;
                border-radius: 50%;
                cursor: pointer;
                box-shadow: 0 0 20px rgba(0, 0, 0, 0.344);
              }

              .indicator {
                position: absolute;
                bottom: 20px;
                right: 20px;
                background: #6EC492;
                padding: 6px 13px;
                font-size: 15px;
                border-radius: 3px;
                color: white;
              }
            }

            h1.name {
              font-weight: 600;
              font-size: 20px;
              margin-bottom: 13px;
            }

            p.descr {
              font-size: 16px;
              opacity: .7;
              margin-bottom: 15px;
            }

            .spaced-skeleton {
              margin-bottom: 15px;
            }

            .split_data_pt {
              display: flex;
              flex-direction: column;
              row-gap: 10px;

              .split_data_pt_crd {
                display: flex;
                font-size: 15px;

                .split_data_pt_crd_more {
                  margin-left: 5px;

                  .b-skeleton {
                    height: 100%;

                    .b-skeleton-item {
                      width: 200px;
                    }
                  }

                  span {
                    i {
                      display: inline-flex;
                      margin: 0 2px;
                    }

                    &:last-of-type {
                      i {
                        display: none;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    .modal_footer {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding: 10px 23px;
      align-items: center;
      background: white;
      z-index: 10;
      border-top: 1px solid #dfdfdf;

      @media (max-width: 580px) {
        flex-direction: column;
        row-gap: 5px;
      }

      span {
        display: flex;
        align-items: center;
      }

      .actions {
        display: flex;
        align-items: center;
        column-gap: 20px;

        @media (max-width: 580px) {
          width: 100%;
          justify-content: space-between;
        }
      }
    }
  }
}
</style>